/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Geplant (Geplant)
 * 
 * 401130000 = inBearbeitung (in Bearbeitung)
 * 
 * 401130002 = Eingereicht (Eingereicht)
 * 
 * 2 = storniert (storniert)
 * 
 * 401130001 = Gepruft (Geprüft)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode {
 Geplant = 1,
 inBearbeitung = 401130000,
 Eingereicht = 401130002,
 storniert = 2,
 Gepruft = 401130001
}

marker([
    "Enum.AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode.Geplant",
    "Enum.AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode.inBearbeitung",
    "Enum.AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode.Eingereicht",
    "Enum.AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode.storniert",
    "Enum.AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode.Gepruft"
]);

export namespace AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode
{
    class DataSets
    {
        static AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscodeDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Geplant", 1, "Geplant"),
            new EnumValue("inBearbeitung", 401130000, "in Bearbeitung"),
            new EnumValue("Eingereicht", 401130002, "Eingereicht"),
            new EnumValue("storniert", 2, "storniert"),
            new EnumValue("Gepruft", 401130001, "Geprüft"),
        )
    }

    export function getAsDataset() {
        return DataSets.AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscodeDataSet;
    }
}
